export default {"src":"/_next/static/media/0xe4d584ae9b753e549cae66200a6475d2f00705f7.ccafe90c.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};